import React from 'react';
import Phone from '@kyruus/react-ikons/Phone';
import { DesktopPhoneWrapper, DesktopPhoneLink } from './styles';
import { getPhone } from './utils';
import { arrayOf, object, bool } from 'prop-types';

function DesktopPhone({ contacts, isLeftAligned }) {
  const phoneNumber = getPhone(contacts);
  const phoneLink = `tel:${phoneNumber}`;

  return (
    <DesktopPhoneWrapper isLeftAligned={isLeftAligned}>
      <Phone size="18px" />
      <DesktopPhoneLink href={phoneLink}>{phoneNumber}</DesktopPhoneLink>
    </DesktopPhoneWrapper>
  );
}

DesktopPhone.propTypes = {
  contacts: arrayOf(object).isRequired,
  isLeftAligned: bool
};

export default DesktopPhone;
